module.exports = __webpack_public_path__ + "img/kati-zoli.6385e7ee.jpg";